import { FeatureFlag } from '../FeatureFlag';

export const enableUnifiedToasts = new FeatureFlag({
    key: 'enable-unified-toasts',
    defaultValue: false,
});
